import { fg } from '@atlaskit/platform-feature-flags/fg';
import { IdentityUserAri } from '@atlassian/ari/identity';
import type { AgentAttribution } from '@atlassian/editor-plugin-ai/types';
import { isAgentType } from '@atlassian/rovo-content-bridge-api-commands/commands/agent-type';

export const getAgentAttribution = ({
	agentType,
	agentIdentityAccountId,
}: {
	agentIdentityAccountId?: string | null;
	agentType?: unknown;
}): AgentAttribution | undefined => {
	if (!fg('platform_editor_agentic_step_attribution')) {
		return undefined;
	}

	const normalizedAgentType = isAgentType(agentType) ? agentType : 'unknown';

	if (!agentIdentityAccountId) {
		return { agentType: normalizedAgentType };
	}

	if (!agentIdentityAccountId.startsWith('ari:')) {
		return { agentId: agentIdentityAccountId, agentType: normalizedAgentType };
	}

	try {
		return {
			agentId: IdentityUserAri.parse(agentIdentityAccountId).userId,
			agentType: normalizedAgentType,
		};
	} catch {
		return { agentType: normalizedAgentType };
	}
};
